"use strict";

$(function () {

    let pageObjects = $('.current_page_parent, .current-page-parent, .current-post-parent, .current_post_parent, .current-menu-item');

    pageObjects.each(function () {
        let classes = $(this).prop('class');
        let parent = $(this).parent();
        let isChildMenu = parent.hasClass('sub-menu');
        let regExp = /object-id-(\d+)/;
        let match = regExp.exec(classes);
        if (match.length > 0) {
            $('.' + match[0]).addClass('current-menu-item');
        }

        if (isChildMenu) {
            parent = parent.parent();
            parent.addClass('current-menu-item');
            match = regExp.exec(parent.prop('class'));
            if (match.length > 0) {
                $('.' + match[0]).addClass('current-menu-item');
            }
        }

    });

    let menuToggle = $('.menu-toggle');
    let searchToggle = $('.search-toggle');
    let floatedMenu = $('.floated-menu');
    let langsToggled = $('.railbaltica-langs');
    menuToggle.click(function (event) {
        event.preventDefault();
        menuToggle.toggleClass('open');
        searchToggle.toggleClass('hide');
        floatedMenu.toggleClass('open');
        langsToggled.toggleClass('open');
    });

    searchToggle.click(function (event) {
        event.preventDefault();
        menuToggle.addClass('open');
        searchToggle.addClass('hide');
        floatedMenu.addClass('open');
        langsToggled.addClass('open');
        $('.search-field').eq(0).focus();
    });

    // gallery
    let gallery = $('.gallery');
    let galleryFloater = $('.image-floater');
    let imgWidth = 700;
    if (gallery.length > 0) {
        gallery.on('click', '.next, .prev', function (event) {
            event.preventDefault();
            let el = $(this);
            if (el.hasClass('disabled')) return;
            let next = el.hasClass('next');
            let id = parseInt(el.data('id'), 10);
            if (isNaN(id)) id = 0;
            let imgCount = parseInt(el.data('max'), 10);
            if (isNaN(imgCount)) imgCount = 0;
            if (!next && id < 0) {
                el.addClass('disabled');
                return;
            }
            if (next && (id - 1) >= imgCount) {
                el.addClass('disabled');
                return;
            }

            let float = 0 - (imgWidth * id);

            galleryFloater.stop().animate({
                marginLeft: float + 'px'
            });

            let prevButton = $('.prev', gallery);
            let nextButton = $('.next', gallery);

            if (next) {
                id++;
                prevButton.data('id', id - 2);
                if (id >= imgCount) {
                    el.addClass('disabled');
                    id--;
                }
                prevButton.removeClass('disabled');
            } else {
                id--;
                nextButton.data('id', id + 2);
                if (id < 0) {
                    el.addClass('disabled');
                    id++;
                }
                nextButton.removeClass('disabled');
            }
            el.data('id', id);

        });
    }
});


// WEBPACK FOOTER //
// ./js/dev/menus.js